import { Grid } from "@mui/material";
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { useWebStoreContext } from "contexts";
import { useAppDispatch, useImagePath } from "hooks";
import { clubGiftsGaloreAssets } from "assets/cdn";
import { onClosePopUp } from "redux/slices";
import { Body, Button, Container, Header, Text, Title } from "./styles";

interface CGGEventCompletedProps {}

export const CGGEventCompleted = ({}: CGGEventCompletedProps) => {
	const dispatch = useAppDispatch();
	const scale = useCalculateScale(363, 420);
	const { getImage } = useImagePath("cdn");
	const tier = clubGiftsGaloreAssets.v2.popups.tier;
	const headImageUrl = getImage(tier.background);
	const { syncUserTracker } = useWebStoreContext();

	const onClose = () => {
		dispatch(onClosePopUp());
	};

	return (
		<Container scale={scale}>
			<Header data-image={headImageUrl}></Header>
			<CloseIconButton onClose={onClose} />
			<Body>
				<Title>
					Your Club has
					<br /> completed the event!
				</Title>
				<Text>
					Check your in-game inbox to claim
					<br /> your bonus prize!
				</Text>
				<Grid container spacing={2}>
					<Grid
						item
						xs={12}
						//sm={isMobile ? 6 : 12}
						display="flex"
						justifyContent="center"
					>
						<Button
							variant="contained"
							themeColor="secondary"
							sx={{
								minWidth: { xs: "80%" /* sm: isMobile ? "100%" : "80%" */ }
							}}
							onClick={() => {
								syncUserTracker();
								dispatch(onClosePopUp());
							}}
						>
							Yay!
						</Button>
					</Grid>
					{/* {isMobile && (
						<Grid item xs={12} sm={6} display="flex" justifyContent="center">
							<BackToGameButton
								source="daily_reward_dialog"
								themeColor="secondary"
								sx={{ minWidth: { xs: "80%", sm: "100%" } }}
							/>
						</Grid>
					)} */}
				</Grid>
			</Body>
		</Container>
	);
};
